import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-js';
import { Box, Grid, Container, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { vehicleActions } from 'state/modules/vehicles';
import BrokersConnection from 'components/BrokersConnection';
import { OrganizationsActions } from 'state/modules/organizations';

const VehicleConnections = ({ currentVehicle, showLabel = true }) => {
  const dispatch = useDispatch();

  const { errors } = useSelector((state) => state.vehicles);
  const { fetchingAvailablesBrokers, availablesBrokers, loading } = useSelector(
    (state) => state.organizations
  );

  const addBrokerToVehicle = (payload, action) => {
    dispatch(vehicleActions.fetchAddBroker(currentVehicle.id, payload, action));
  };

  const removeBroker = (value) => {
    dispatch(vehicleActions.fetchRemoveBroker(currentVehicle?.id, value?.broker_slug));
  };

  useEffect(() => {
    dispatch(OrganizationsActions.fetchAvailablesBrokers({ class_slug: 'VH' }));
  }, [dispatch]);

  return (
    <Box>
      <Container className="h-100" sx={{ pl: 0, pr: 0 }}>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <Typography gutterBottom component="div" align="left">
              <Box sx={{ fontWeight: 500, fontSize: 14, pr: 4, mt: 2, mb: 4 }}>
                {showLabel ? i18n.t('vehicle.select_broker') : ''}
              </Box>
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <BrokersConnection
              availables={{
                list: [...availablesBrokers],
                loading: fetchingAvailablesBrokers,
              }}
              errors={errors}
              loading={loading}
              onRemoveBroker={removeBroker}
              onAddBroker={addBrokerToVehicle}
              assigned={currentVehicle?.brokers || {}}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

VehicleConnections.propTypes = {
  currentVehicle: PropTypes.object,
  showLabel: PropTypes.bool,
};

export default VehicleConnections;
